//todo: split into files
export var CoreModalID;
(function (CoreModalID) {
    CoreModalID["Login"] = "Login";
    CoreModalID["SignUp"] = "SignUp";
    CoreModalID["ForgotPasswordStart"] = "ForgotPasswordStart";
    CoreModalID["ForgotPasswordConfirm"] = "ForgotPasswordConfirm";
})(CoreModalID || (CoreModalID = {}));
